import { normalize, highlightAccent, unhighlightAccent } from "../../utils";

export function initSearchInPage() {
	const input = document.getElementById("pageSearchInput");
	const clearBtn = document.getElementById("clearPageSearch");
	if (!input) return;

	const scope =
		document.querySelector("main") ||
		document.querySelector("#content") ||
		document.body;

	const widget = document.getElementById("search-in-page");

	function doHighlight(term) {
		if (!term) return;
		const rx = new RegExp(
			normalize(term).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
			"gi"
		);
		highlightAccent(scope, [rx], "mt-page-highlight", widget);
	}

	function doUnhighlight() {
		unhighlightAccent(scope, "mt-page-highlight");
	}

	input.addEventListener("input", () => {
		const term = input.value.trim();
		doUnhighlight();
		if (term) doHighlight(term);
	});

	if (clearBtn) {
		clearBtn.addEventListener("click", () => {
			input.value = "";
			doUnhighlight();
			input.focus();
		});
	}
}
